import PANE from '../../../../../APP/page/pane/PANE.js';
import { Disable, Enable } from '../../../../../../interface/Disableable.js';
import { textBlock } from '../../../../../DOM/div/TEXTBLOCK/TEXTBLOCK.js';
import { footer } from '../../../../../DOM/footer/FOOTER.js';
import { heading } from '../../../../../DOM/heading/HEADING.js';
import { text } from '../../../../../DOM/text/TEXT.js';
import { div } from '../../../../../DOM/div/DIV.js';
import { span } from '../../../../../DOM/span/SPAN.js';
import FORM, { form } from '../../../../../DOM/form/FORM.js';
import { hero } from '../../../../../COMPONENT/hero/HERO.js';
import { navbar } from '../../../../../DOM/nav/navbar/NAVBAR.js';
import { fieldset } from '../../../../../DOM/form/fieldset/FIELDSET.js';
import { formFieldGroup } from '../../../../../DOM/form/fieldset/formfieldgroup/FORMFIELDGROUP.js';
import { formInputText } from '../../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTTEXT.js';
import { formInputTel } from '../../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTTEL.js';
import { formInputTime } from '../../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTTIME.js';
import { formInputRadio } from '../../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTRADIO.js';
import { formSelect } from '../../../../../DOM/form/fieldset/formfieldgroup/formfield/formselect/FORMSELECT.js';
import { formTextarea } from '../../../../../DOM/form/fieldset/formfieldgroup/formfield/formtextarea/FORMTEXTAREA.js';
import { HTTPMETHOD } from '../../../../../../enums/HTTPMETHOD.js';
import { legend } from '../../../../../DOM/form/fieldset/legend/LEGEND.js';
import { label } from '../../../../../DOM/form/label/LABEL.js';
import { inputText } from '../../../../../DOM/form/fieldset/field/input/inputs/INPUTTEXT.js';
import { inputTel } from '../../../../../DOM/form/fieldset/field/input/inputs/INPUTTEL.js';
import { inputTime } from '../../../../../DOM/form/fieldset/field/input/inputs/INPUTTIME.js';
import { inputRadio } from '../../../../../DOM/form/fieldset/field/input/inputs/INPUTRADIO.js';
import { textarea } from '../../../../../DOM/form/fieldset/field/textarea/TEXTAREA.js';
import { select } from '../../../../../DOM/form/fieldset/field/select/SELECT.js';
import { option } from '../../../../../DOM/form/fieldset/field/option/OPTION.js';
import { Show, Hide } from '../../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import { button } from '../../../../../DOM/button/BUTTON.js';
import { SVGS } from '../../../../../SVG/SVGS.js';
import { icon } from '../../../../../SVG/icon/ICON.js';
import NAVHEADER, { navheader } from '../../../../../DOM/nav/navbar/navheader/NAVHEADER.js';
import { navfooter } from '../../../../../DOM/nav/navbar/navfooter/NAVFOOTER.js';
import { ul } from '../../../../../DOM/LIST/ul/UL.js';
import { li } from '../../../../../DOM/LIST/li/LI.js';
import Click from '../../../../../../event/Click.js';
import CONFIRM, { confirmEl } from '../../../../../COMPONENT/dialog/confirm/CONFIRM.js';
import Translate from '../../../../../../event/Translate.js';
import Movable, { Move } from '../../../../../../interface/Movable.js';
import { DIRECTION } from '../../../../../../enums/DIRECTION.js';
import CONFIRM_ReviewBreach from '../../../../../APP/page/dialog/confirm/CONFIRM_ReviewBreach.js';
import InvalidFormFieldError from '../../../../../../error/InvalidFormFieldError.js';
/** A Panel that visualizes Tabular Data */
export default class PANE_Home_Index extends PANE {
    form;
    constructor(node, model) {
        super(node, model);
        this.addClass('full-frame');
        this.addClass('pane-ethic-hotline');
        this.buildUI();
    }
    /** Asynchronously builds the UI elements for the panel.
        @returns {void}
    */
    buildUI() {
        this.logInfo('Building Ethics Hotline Report Form UI...');
        let config = this.getMain().getConfig();
        // Construct the UI elements
        this.hero = this.addHero(hero(undefined, undefined, div(), heading(1, '', undefined, 'EthicsHotlineGeneral', 'EthicsHotline'), heading(2, '', undefined, 'EthicsHotlineGeneral', 'ReportAConcern'), text('', undefined, 'EthicsHotlineGeneral', 'SpeakUp')));
        // A sticky header that remains visible as users scroll through the form, providing easy access to navigation and important information.
        this.formHeader = new NAVHEADER(this, navheader('formHeader', 'formHeader', span('Ethics Breach Form'), icon(SVGS.ETHICS_48PX)));
        this.formHeader.addClass('form-header');
        let btnSave = this.formHeader.navRight.addButton(button(span('Save'), 'btn-save', icon(SVGS.DISK_48PX), 'Review your report before submitting'), 'review-report');
        btnSave.on('click', () => this.reviewConfirmation(btnSave));
        // Ethics Hotline Form
        this.form = new FORM(this, form('ethic-hotline', 'form-ethic-hotline', `${config.app.apiEndpoint}/ethics/breach/new`, HTTPMETHOD.POST));
        // FIELDSET: Breach Type
        this.fsBreach = this.form.addFieldset(fieldset('breach-type-fs', undefined, legend('', 'EthicsHotlineGeneral', 'BreachType')));
        this.fsBreachDescription = this.fsBreach.addP(text('', undefined, 'EthicsHotlineGeneral', 'BreachTypeDesc'));
        this.breachTypes = this.fsBreach.addFormFieldGroup(formFieldGroup('breach-type-group', 'radio-group'));
        this.breachTypeDescription = this.fsBreach.addDiv(div(undefined, 'breach-type-info')).addTextblock(textBlock());
        // Add breach types dynamically from config
        // Breach Types - rebuild from config (dynamic content)
        // this.logInfo('Building breach type radios from config...');
        let breachRadios = [];
        let cfgBreachType = config.translation.text[config.translation.language.code].EthicalBreachType;
        Object.keys(cfgBreachType).forEach((key) => {
            this.breachTypes.addFormInputRadio(formInputRadio(label('', undefined, undefined, 'EthicalBreachType', key), inputRadio('breach-type', key))).getField().on('click', () => {
                this.breachTypeDescription.data.textGroup = 'EthicalBreachTypeSummary';
                this.breachTypeDescription.data.textKey = `${key}Summary`;
                try {
                    let summary = this.getMain().getConfig().translation.text[this.getMain().getConfig().translation.language.code]['EthicalBreachTypeSummary'][`${key}Summary`].value;
                    this.breachTypeDescription.setInnerHTML(summary || '');
                }
                catch (error) {
                    this.logError('Error updating breach type description:', error);
                    this.breachTypeDescription.setInnerHTML('Description unavailable.');
                }
            });
        });
        this.breachTypes.get()[0].do(new Click(this));
        // FIELDSET: Remain Anonymous?
        this.fsAnonymous = this.form.addFieldset(fieldset('contact-anonymous-fs', undefined, legend('', 'EthicsHotlineGeneral', 'ContactAnonymous')));
        this.fsAnonymousDescription = this.fsAnonymous.addP(text('', undefined, 'EthicsHotlineGeneral', 'ContactAnonymousDesc'));
        this.hasManagementField = false;
        this.fsAnonymousFG = this.fsAnonymous.addFormFieldGroup(formFieldGroup('contact-anonymous-group', 'radio-group'));
        this.fsAnonymousRadio_No = this.fsAnonymousFG.addFormInputRadio(formInputRadio(label('', undefined, undefined, 'Generic', 'No'), inputRadio('contact-anonymous', 'No', undefined, true))).on('click', () => {
            if (typeof this.fsContact !== 'undefined') {
                this.fsContact.do(new Show(this));
                // Enable all fields in Contact Information fieldset
                this.fsContact.get(null, 'FORMFIELDGROUP').forEach((ffg) => {
                    ffg.getFormFields().forEach((field) => field.do(new Enable(this)));
                });
                this.fsContactDate.do(new Show(this));
                // Enable all fields in Contact Dates fieldset
                this.fsContactDate.get(null, 'FORMFIELDGROUP').forEach((ffg) => {
                    ffg.getFormFields().forEach((field) => field.do(new Enable(this)));
                });
            }
        });
        this.fsAnonymousRadio_Yes = this.fsAnonymousFG.addFormInputRadio(formInputRadio(label('', undefined, undefined, 'Generic', 'Yes'), inputRadio('contact-anonymous', 'Yes'))).on('click', () => {
            if (typeof this.fsContact !== 'undefined') {
                this.fsContact.reset();
                this.fsContact.do(new Hide(this));
                // Disable all fields in Contact Information fieldset
                this.fsContact.get(null, 'FORMFIELDGROUP').forEach((ffg) => {
                    ffg.getFormFields().forEach((field) => field.do(new Disable(this)));
                });
                this.fsContactDate.reset();
                this.fsContactDate.do(new Hide(this));
                // Disable all fields in Contact Dates fieldset
                this.fsContactDate.get(null, 'FORMFIELDGROUP').forEach((ffg) => {
                    ffg.getFormFields().forEach((field) => field.do(new Disable(this)));
                });
            }
        });
        this.fsAnonymousFG.getFormFields()[0].do(new Click(this));
        // FIELDSET: Contact Information
        this.fsContact = this.form.addFieldset(fieldset('contact-info-fs', undefined, legend('', 'EthicsHotlineGeneral', 'ContactInformation')));
        this.fsContactDescription = this.fsContact.addP(text('', undefined, 'EthicsHotlineGeneral', 'ContactInformationDesc'));
        this.fsContactInfoGroup = this.fsContact.addFormFieldGroup(formFieldGroup('contact-group'));
        this.fsContactInfoNameFirst = this.fsContactInfoGroup.addFormInputText(formInputText(label('', undefined, undefined, 'Contact', 'FirstName'), inputText('first-name'))).setAttribute('name', 'first-name');
        this.fsContactInfoNameLast = this.fsContactInfoGroup.addFormInputText(formInputText(label('', undefined, undefined, 'Contact', 'LastName'), inputText('last-name'))).setAttribute('name', 'last-name');
        this.fsContactInfoEmail = this.fsContactInfoGroup.addFormInputText(formInputText(label('', undefined, undefined, 'Contact', 'EmailAddress'), inputText('email-address'))).setAttribute('name', 'email-address');
        this.fsContactInfoPhone = this.fsContactInfoGroup.addFormInputTel(formInputTel(label('', undefined, undefined, 'Contact', 'PhoneNumber'), inputTel('phone-number'))).setAttribute('name', 'phone-number');
        // Phone validation will be populated with translated text in asyncPopulatePage
        this.fsContactInfoPhone.getField().on('input', () => {
            const phoneInput = this.fsContactInfoPhone.getField();
            if (!phoneInput.checkValidity()) {
                if (this.fsContactInfoPhone.getAttribute('required')) {
                    const errorMsg = this.getMain().getStringByParam(this.getMain().getConfig().translation.language.code, 'EthicsHotlineGeneral', 'key', 'EnterValidPhoneNum');
                    console.log('Phone input invalid and required:', phoneInput.getValue());
                    this.fsContactInfoPhone.getMessage().setInnerHTML(errorMsg).addClass('error').do(new Show(this.fsContactInfoPhone));
                }
                else {
                    if (phoneInput.getValue() !== '' && phoneInput.getValue() !== null && phoneInput.getValue() !== undefined) {
                        const errorMsg = this.getMain().getStringByParam(this.getMain().getConfig().translation.language.code, 'EthicsHotlineGeneral', 'key', 'EnterValidPhoneNum');
                        // console.log('Phone input invalid but optional:', phoneInput.getValue());
                        this.fsContactInfoPhone.getMessage().setInnerHTML(errorMsg).addClass('error').do(new Show(this.fsContactInfoPhone));
                    }
                    else {
                        this.fsContactInfoPhone.getMessage().setInnerHTML('').removeClass('error').do(new Hide(this.fsContactInfoPhone));
                    }
                }
            }
            else {
                this.fsContactInfoPhone.getMessage().setInnerHTML('').removeClass('error').do(new Hide(this.fsContactInfoPhone));
            }
        });
        // FIELDSET: Contact Dates
        this.fsContactDate = this.form.addFieldset(fieldset('contact-dates-fs', undefined, legend('', 'EthicsHotlineGeneral', 'ContactDates')));
        this.fsContactDateDescription = this.fsContactDate.addP(text('', undefined, 'EthicsHotlineGeneral', 'ContactDatesDesc'));
        this.fsContactDateDaysDescription = this.fsContactDate.addP(text('', undefined, 'EthicsHotlineGeneral', 'PreferredContactDatesAndTimes'));
        this.contactDateGroups = [];
        this.fsDatesNavbar = this.fsContactDate.addNavBar(navbar('minimal'));
        this.btn_fsDate_Remove = this.fsDatesNavbar.navRight.addButton(button(span(''), 'remove-date', icon(SVGS.MINUS_48PX, 'Remove'), '')).on('click', () => this.removeDateField(this.contactDateGroups[this.contactDateGroups.length - 1]));
        this.btn_fsDate_Add = this.fsDatesNavbar.navRight.addButton(button(span(''), 'add-date', icon(SVGS.PLUS_48PX, 'Add'), '')).on('click', () => this.addDateField());
        this.addDateField();
        // FIELDSET: Breach Details
        this.fsDetails = this.form.addFieldset(fieldset('breach-details-fs', undefined, legend('', 'EthicsHotlineGeneral', 'BreachDetails')));
        this.fsDetailsDescription = this.fsDetails.addP(text('', undefined, 'EthicsHotlineGeneral', 'BreachDetailsDesc'));
        // NavBar > Add/Remove Individual(s)
        this.personsEngaged = [];
        this.fsDetailsNavbar = this.fsDetails.addNavBar(navbar('minimal'));
        this.btn_fsDetails_Remove = this.fsDetailsNavbar.navRight.addButton(button(span(''), 'remove-individual', icon(SVGS.MINUS_48PX, 'Remove'), '')).on('click', () => this.removeDetailField(this.personsEngaged[this.personsEngaged.length - 1]));
        this.btn_fsDetails_Add = this.fsDetailsNavbar.navRight.addButton(button(span(''), 'add-individual', icon(SVGS.PLUS_48PX, 'Add'), '')).on('click', () => this.addDetailField());
        this.addDetailField();
        // FIELDSET: Management Involved?
        this.fsMgmtInvolved = this.form.addFieldset(fieldset('management-involved-fs', undefined, legend('', 'EthicsHotlineGeneral', 'MgmtInvolved')));
        this.fsMgmtInvolvedDescription = this.fsMgmtInvolved.addP(text('', undefined, 'EthicsHotlineGeneral', 'MgmtInvolvedDesc'));
        this.hasManagementField = false;
        this.fsMgmtInvolvedFG = this.fsMgmtInvolved.addFormFieldGroup(formFieldGroup('management-involved-group', 'radio-group'));
        this.fsMgmtInvolvedRadio_No = this.fsMgmtInvolvedFG.addFormInputRadio(formInputRadio(label('', undefined, undefined, 'Generic', 'No'), inputRadio('management-involved', 'No', undefined, true))).on('click', () => this.removeManagementField());
        this.fsMgmtInvolvedRadio_Yes = this.fsMgmtInvolvedFG.addFormInputRadio(formInputRadio(label('', undefined, undefined, 'Generic', 'Yes'), inputRadio('management-involved', 'Yes'))).on('click', () => this.addManagementField());
        this.fsMgmtInvolvedFG.getFormFields()[0].do(new Click(this));
        // FIELDSET: Breach Comments
        this.fsNotes = this.form.addFieldset(fieldset('breach-notes-fs', undefined, legend('', 'EthicsHotlineGeneral', 'BreachComments')));
        this.fsNotesDescription = this.fsNotes.addP(text('', undefined, 'EthicsHotlineGeneral', 'BreachCommentsDesc'));
        this.fsNotesFieldGroup = this.fsNotes.addFormFieldGroup(formFieldGroup('breach-notes-group'));
        this.fsNoteField = this.fsNotesFieldGroup.addFormTextarea(formTextarea(label('', undefined, undefined, 'EthicsHotlineGeneral', 'Comments'), textarea('breach-notes', 4096, '', true, 8)));
        // // SECTION: Review and Submit
        // this.review = this.addDiv(div('review-div'));
        // this.reviewTextBlock = this.review.addTextblock(text('', undefined, 'EthicsHotlineGeneral', 'ReviewDesc'));
        // this.reviewBtnGroup = this.addButtonGroup(buttongroup('review-btn-group', 'vertical')).insertInto(this.review);
        // this.reviewBtn = this.reviewBtnGroup.addButton(button(span('', undefined, 'EthicsHotlineGeneral', 'Review'), 'review-report', icon(SVGS.BLANK)));
        // this.reviewBtn.addClass('btn-review-report submit').on('click', () => this.reviewConfirmation(this.reviewBtn));
        this.footer = this.addFooter(footer());
        this.footerCite = this.footer.addCite(text(''));
        this.footerCite.addSpan(span('', undefined, 'Generic', 'LastModified'));
        this.footerCite.addSpan(span(': 2026-01-08'));
        this.getMain().translate();
        // this.logInfo('Ethics Hotline Report Form UI built successfully.');
        // this.logDebug('Config', this.getMain().getConfig());
    }
    /** Adds the management field group
        @return void
    */
    addManagementField() {
        if (this.hasManagementField === true) {
            return;
        }
        console.log('Adding management field group');
        let fieldset = this.form.getFieldset('management-involved-fs')[0];
        let fsManagementFieldGroup = fieldset.addFormFieldGroup(formFieldGroup('management-involved-detail'));
        fsManagementFieldGroup.addFormInputText(formInputText(label('', undefined, undefined, 'Contact', 'FirstName'), inputText('first-name', '', '', '', true))).setAttribute('name', 'first-name');
        fsManagementFieldGroup.addFormInputText(formInputText(label('', undefined, undefined, 'Contact', 'LastName'), inputText('last-name', '', '', '', true))).setAttribute('name', 'last-name');
        fsManagementFieldGroup.addFormInputText(formInputText(label('', undefined, undefined, 'Contact', 'Department'), inputText('department', '', '', '', true))).setAttribute('name', 'department');
        fsManagementFieldGroup.get().forEach((ff) => {
            console.log('Translating management field:', ff);
            ff.label.do(new Translate(ff.label, this.getMain().getConfig().translation.language.code));
            ff.getField().do(new Enable(this));
        });
        this.hasManagementField = true;
    }
    /** Removes the management field group
        @return void
    */
    removeManagementField() {
        let fieldset = this.form.getFieldset('management-involved-fs')[0];
        try {
            fieldset.getFormFieldGroup('management-involved-detail')[0].destroy();
        }
        catch (e) {
            // this.logInfo('No management field to remove');
        }
        this.hasManagementField = false;
    }
    /** Adds a new date field for contacting individuals
        Limits to a maximum of 5 dates
        @return void
    */
    addDateField() {
        let dateLimit = 5;
        if (this.contactDateGroups.length >= dateLimit) {
            alert(`You have reached the maximum number of dates (${dateLimit}) that can be reported at one time.`);
            return;
        }
        let fieldset = this.form.getFieldset('contact-dates-fs')[0];
        let ffGroup = fieldset.addFormFieldGroup(formFieldGroup('contact-dates-group'));
        ffGroup.implement(new Movable(ffGroup));
        let ffGroupNavbar = ffGroup.addNavBar(navbar('minimal'));
        ffGroupNavbar.navRight.addButton(button(span(''), 'promote-date', icon(SVGS.ARROW_UP_48PX, 'Promote'))).on('click', () => {
            let prev = ffGroup.getPrev();
            console.log('Previous sibling:', prev);
            if (typeof prev === 'undefined' || prev === null) {
                console.log('No previous sibling, cannot promote further');
                return; // Already at the top
            }
            if (prev.className === 'NAVBAR') {
                console.log('No previous sibling, cannot promote further');
                return; // Already at the top
            }
            ffGroup.do(new Move(this, DIRECTION.UP));
        }).setTitle('');
        ffGroupNavbar.navRight.addButton(button(span(''), 'demote-date', icon(SVGS.ARROW_DOWN_48PX, 'Demote'))).on('click', () => {
            let next = ffGroup.getNext();
            console.log('Next sibling:', next);
            if (typeof next === 'undefined' || next === null) {
                console.log('No next sibling, cannot demote further');
                return; // Already at the bottom
            }
            ffGroup.do(new Move(this, DIRECTION.DOWN));
        }).setTitle('');
        ffGroupNavbar.navRight.addButton(button(span(''), 'remove-date', icon(SVGS.CLOSE_48PX, 'Remove'))).on('click', () => this.removeDateField(ffGroup)).setTitle('');
        // Form Items
        let dateSelect = ffGroup.addFormSelect(formSelect(label('', undefined, undefined, 'Generic', 'Date'), select('preferred-contact-date'))).setAttribute('name', 'preferred-contact-date');
        ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'].forEach(day => {
            // console.log('Adding contact day checkbox for', day);
            let translation = this.getMain().getStringByParam(this.getMain().getConfig().translation.language.code, 'Day', 'key', day);
            // TODO: Use translated day names in `label`
            dateSelect.getField().addOption(option(translation, day));
        });
        ffGroup.addFormInputTime(formInputTime(label('', undefined, undefined, 'Generic', 'After'), inputTime('time-start'))).setAttribute('name', 'time-start');
        ffGroup.addFormInputTime(formInputTime(label('', undefined, undefined, 'Generic', 'Before'), inputTime('time-end'))).setAttribute('name', 'time-end');
        ffGroup.get().forEach((ff) => {
            // console.log('Translating date field:', ff);
            if (ff.className === 'FORMSELECT' || ff.className === 'FORMINPUTTIME') {
                ff.label.do(new Translate(ff.label, this.getMain().getConfig().translation.language.code));
            }
        });
        this.contactDateGroups.push(ffGroup);
    }
    /** Remove the given dateGroup
        @return void
    */
    removeDateField(dateGroup) {
        if (this.contactDateGroups.length === 1) {
            new CONFIRM(this.getMain().getBody(), confirmEl('review-error', 'error no-cancel', this, navheader(), navfooter(), text('Must have at least one contact date reported.'))).show();
            return;
        }
        this.contactDateGroups = this.contactDateGroups.filter((group) => group !== dateGroup);
        dateGroup.remove();
    }
    /** Adds a new detail field for reporting individuals
        Limits to a maximum of 10 individuals
        @return void
    */
    addDetailField() {
        let personLimit = 10;
        if (this.personsEngaged.length >= personLimit) {
            alert(`You have reached the maximum number of individuals (${personLimit}) that can be reported at one time.`);
            return;
        }
        let fieldset = this.form.getFieldset('breach-details-fs')[0];
        let ffGroup = fieldset.addFormFieldGroup(formFieldGroup('breach-details-group'));
        let ffGroupNavbar = ffGroup.addNavBar(navbar('minimal'));
        ffGroupNavbar.navRight.addButton(button(span(''), 'remove-individual', icon(SVGS.CLOSE_48PX, 'Remove'))).on('click', () => this.removeDetailField(ffGroup)).setTitle('');
        // Form Items
        ffGroup.addFormInputText(formInputText(label('', undefined, undefined, 'Contact', 'FirstName'), inputText('first-name', '', '', '', true))).setAttribute('name', 'first-name');
        ffGroup.addFormInputText(formInputText(label('', undefined, undefined, 'Contact', 'LastName'), inputText('last-name', '', '', '', true))).setAttribute('name', 'last-name');
        ffGroup.addFormInputText(formInputText(label('', undefined, undefined, 'Contact', 'Department'), inputText('department', '', '', '', true))).setAttribute('name', 'department');
        ffGroup.get(undefined, 'FORMINPUTTEXT').forEach((ff) => {
            // console.log('Translating detail field:', ff);
            ff.label.do(new Translate(ff.label, this.getMain().getConfig().translation.language.code));
        });
        this.personsEngaged.push(ffGroup);
        // If config is loaded, populate the new fields immediately
        if (this.config && this.config.translate && this.config.translation.language.code) {
            const firstName = this.getMain().getStringByParam(this.config.translation.language.code, 'Contact', 'key', 'FirstName');
            const lastName = this.getMain().getStringByParam(this.config.translation.language.code, 'Contact', 'key', 'LastName');
            const department = this.getMain().getStringByParam(this.config.translation.language.code, 'Contact', 'key', 'Department');
            ffGroup.get('first-name')[0].getLabel().setInnerHTML(firstName);
            ffGroup.get('first-name')[0].getField().setAttribute('placeholder', firstName);
            ffGroup.get('last-name')[0].getLabel().setInnerHTML(lastName);
            ffGroup.get('last-name')[0].getField().setAttribute('placeholder', lastName);
            ffGroup.get('department')[0].getLabel().setInnerHTML(department);
            ffGroup.get('department')[0].getField().setAttribute('placeholder', department);
        }
    }
    /** Remove the given detailGroup
        @return void
    */
    removeDetailField(detailGroup) {
        if (this.personsEngaged.length === 1) {
            new CONFIRM(this.getMain().getBody(), confirmEl('review-error', 'error no-cancel', this, navheader(), navfooter(), text('Must have at least one individual reported.'))).show();
            return;
        }
        this.personsEngaged = this.personsEngaged.filter((group) => group !== detailGroup);
        detailGroup.remove();
    }
    /** Triggers a CONFIRM dialog
        @param {EL<HTMLElementModel>} caller - The element that triggered the confirmation
        @return void
    */
    reviewConfirmation(caller) {
        console.log('Reviewing Ethics Hotline Report Form before submission...');
        // Check for errors
        let formFields = this.form.getFormFields();
        let errors = [];
        formFields.forEach((formField) => {
            formField.setError(formField.getField().checkValidity() ? null : new InvalidFormFieldError(formField));
            let error = formField.getError();
            if (error !== null) {
                errors.push(error);
                formField.addClass('invalid');
                // formField.getMessage().setInnerHTML(error.message).addClass('error').do(new Show(this));
            }
            else {
                // formField.getMessage().setInnerHTML('').removeClass('error').do(new Hide(this));
                formField.removeClass('invalid');
            }
        });
        if (errors.length > 0) {
            console.log('Form has validation errors', errors);
            let confirm = new CONFIRM(this.getMain().getBody(), confirmEl('review-error', 'error no-cancel', caller, navheader(), navfooter(), text('There was an error submitting your report.')));
            let errorList = confirm.content.addUL(ul('error-list-ul'));
            errors.forEach((error) => errorList.addLI(li(error.message)));
            confirm.show();
            return;
        }
        // No errors, proceed to review
        let formResults = this.form.getResults();
        let confirm = new CONFIRM_ReviewBreach(this.getMain().getBody(), confirmEl('confirm-review-breach', 'confirm-review-breach', caller, navheader(), navfooter(), text('', undefined, 'EthicsHotlineGeneral', 'ReviewDialogMsg'), () => {
            console.log('Confirmed review of Ethics Hotline Report Form', formResults);
            this.getJson(`${this.getMain().getConfig().app.apiEndpoint}/ethics/breach/new`, (response) => {
                console.log('Received response from Ethics Hotline Report submission:', response);
                if (response.breachId === undefined || response.breachId === null) {
                    new CONFIRM(this.getMain().getBody(), confirmEl('submit-error', 'error no-cancel', caller, navheader(), navfooter(), text('There was an error submitting your report.'))).show();
                    return;
                }
                else {
                    let msg = `Thank you for submitting your report. Your unique report ID is<br><cite>${response.breachId}</cite>`;
                    new CONFIRM(this.getMain().getBody(), confirmEl('info-success', 'info no-cancel', caller, navheader(), navfooter(), text(msg))).show();
                }
                this.form.reset();
            }, HTTPMETHOD.POST, undefined, undefined, formResults);
        }, () => {
            new CONFIRM(this.getMain().getBody(), confirmEl('submit-cancel', 'info no-cancel', caller, navheader(), navfooter(), text('Cancelled review of Ethics Hotline Report Form'))).show();
        }));
        confirm.populateBreachSummary(formResults);
        console.log('Showing review confirmation dialog', this.form.getResults());
        confirm.show();
    }
}
